import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { createSelector } from 'reselect';

import { SubscriptionModalStore } from 'common.components/lesson-view.subscription-modal/typings';
import { getSlugFromProps } from 'utils/selectors/selectors';

interface StoreWithSubscriptionModal {
    subscriptionModal: SubscriptionModalStore;
}

const subscriptionModalStoreSelector = <T extends StoreWithSubscriptionModal>(store: T) => store.subscriptionModal;

export const getIsModalOpened = createSelector([subscriptionModalStoreSelector], (state) => state.opened);

export const getModalMode = createSelector([subscriptionModalStoreSelector], (state) => state.mode);

export const getLoadingStatus = createSelector([subscriptionModalStoreSelector, getSlugFromProps], (state, slug) =>
    slug ? state.loadingStatuses[slug] : LOADING_STATUSES.UNSENT
);

export const getIsLoading = createSelector([getLoadingStatus], (status) => status === LOADING_STATUSES.LOADING);
